var moment = require('moment-timezone');
var momentDurationFormatSetup = require('moment-duration-format');
momentDurationFormatSetup(moment);

//12:45 => 12.75
function convertStringTimeToNumber(time: string): number {
  return moment.duration(time).asHours();
}

//12.75 => 12:45
function convertNumberTimeToString(hours: number) {
  if(!hours) return '00:00'
  var duration = moment.duration(hours, 'hours');
  return duration.format('h:mm');
}

//12:45:00 => 12:45
function formatTime(time: string) {
  if(!time) return '00:00'
  var duration = moment.duration(convertStringTimeToNumber(time), 'hours');
  return duration.format('h:mm');
}


export const DateUtils = {
  convertStringTimeToNumber,
  convertNumberTimeToString,
  formatTime,
};